import React, { useState, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import '../../styles/Auth.css'
import AuthService from '../../services/auth.service'
import 'react-simple-keyboard/build/css/index.css'

import 'react-toastify/dist/ReactToastify.css'
import { AUTH_KEYS} from '../../utils/translation-constants'
import AuthLayout from './auth-layout'
import LoginMobile from 'custom/assets/landing/login-mobile.svg'
import NeoOTPVerify from '../../components/FormComponents/NeoOTPVerify'

export default function OTPVerify() {
  const history = useHistory()
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [otpNo, setOtpNo] = useState('')

  const postVerifyOTP = useCallback(async () => {
    try {
      setLoading(true)
      const params = {
        otpNo: otpNo,
      }
      const response = await AuthService.verifyOTP(params)
      if (response.status === 200) {
        history.push('/dashboard')
        setLoading(false)
        AuthService.getUserProfile()
        AuthService.getUserProfileImage()
        AuthService.featureCheck()
      }
    } catch (err) {
      setLoading(false)
      setOtpNo('')
    }
  }, [otpNo])

  return (
    <AuthLayout>
      <h2 className='app-name'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.LOGIN_KEYS.APP_NAME)}</h2>
      <div className='text-center'>
        <img
          className=''
          style={{ margin: '0 auto' }}
          src={LoginMobile}
          alt='mobile logo'
          height='100'
        />
      </div>
      <div className='mx-auto' style={{ width: 350, height: 350 }}>
        <NeoOTPVerify otp={otpNo} setOTP={setOtpNo} onSubmit={postVerifyOTP} loading={loading} />
      </div>
    </AuthLayout>
  )
}
